import React from 'react';
import Cookies from 'js-cookie';
import { ActivityCalendar } from 'react-activity-calendar';
import { FiActivity, FiAward, FiBox, FiBriefcase, FiCalendar, FiCheckCircle, FiClock, FiLoader, FiLogOut, FiMapPin, FiMoreVertical, FiPlus, FiThumbsUp, FiTrendingUp, FiUser, FiUserMinus, FiUserPlus, FiX } from 'react-icons/fi';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import styles from './Dashboard.module.css';
import * as utils from '../../utils/utils';
import Sidebar from '../Sidebar/Sidebar';
import HQDialog from '../HQDialog/HQDialog';
import HQToast from '../HQToast/HQToast';
import DashboardCheckIns from './DashboardCheckIns/DashboardCheckIns';
import DashboardChatter from './DashboardChatter/DashboardChatter';
import DashboardExperience from './DashboardExperience/DashboardExperience';
import DashboardEducation from './DashboardEducation/DashboardEducation';
import HQBeta from '../HQBeta/HQBeta';

export default class Dashboard extends React.Component {

	constructor(props) {
		super(props);

		this.screens = {
			checkIns: 1,
			chatter: 2,
			experience: 3,
			education: 4,
		};

		this.educationLayoutShellDialogHost = null;
		this.chatterLayoutShellDialogHost = null;
		this.experienceLayoutShellDialogHost = null;
		

		const currentUserNickname = utils.getUserNickname() || '';
		let nickname = this.props.match.params.nickname || '';

		let isSelf = true;
		if (nickname !== '') {
			isSelf = nickname.toLowerCase() === currentUserNickname.toLowerCase();
		}
		else {
			nickname = currentUserNickname;
		}

		this.state = {
			isLoading: true,
			isResumeProcessing: false,
			isLoadingMore: false,
			errorText: '',

			nickname,
			isSelf,

			currentScreen: this.screens.checkIns,

			firstName: '',
			lastName: '',
			inviteCode: '',
			numInvitesLeft: 0,
			isFollowing: -1,
			currentStreak: 0,
			longestStreak: 0,
		};
	};

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		this.loadDashboardData();
	};

	componentDidUpdate(prevProps) {
		const prevNickname = prevProps.match.params.nickname || '';
		const currentNickname = this.props.match.params.nickname || '';

		const currentUserNickname = utils.getUserNickname() || '';

		if (prevNickname !== currentNickname) {
			let isSelf = true;
			if (currentNickname) {
				isSelf = currentNickname.toLowerCase() === currentUserNickname.toLowerCase();
			}
			this.setState({
				nickname: currentNickname,
				isSelf,
			}, this.loadDashboardData);
		}
	}

	componentWillUnmount() {
	};

	getUserIDKey = () => {
		if (utils.isDev) {
			return 'User-Id-Dev';
		}

		return 'User-Id';
	};

	getCurrentUserID = () => {
		const userID = Cookies.get(this.getUserIDKey());
		return Number(userID);
	};

	// normalizeCalendarData = (graph) => {
	// 	const maxCount = graph.reduce((max, item) => {
	// 		return Math.max(max, item.count || 0);
	// 	}, 0);

	// 	return graph.map((item) => {
	// 		const count = Number(item.count) || 0;

	// 		let level = 0;
	// 		if (count > 0 && maxCount > 0) {
	// 			level = Math.min(4, Math.max(1, Math.ceil((count / maxCount) * 4)));
	// 		}

	// 		return {
	// 			date: item.day,
	// 			count,
	// 			level,
	// 		};
	// 	});
	// };

	loadDashboardData = () => {
		const userID = this.getCurrentUserID();

		if (!Number.isInteger(userID) || userID <= 0) {
			this.setState({
				isLoading: false,
				errorText: 'Could not identify your account. Please sign in again.',
			});
			return;
		}

		const requests = [];

		if (this.state.nickname) {
			requests.push(utils.sendRequest('/profile/getUserProfile', { nickname: this.state.nickname }));
		}
		else {
			requests.push(utils.sendRequest('/profile/getUserProfile', {}));
			requests.push(utils.sendRequest('/meta/getIsAResumeProcessing', {}));
		}

		Promise.all(requests)
			.then(([
				profileResponse,
				metaResponse,
			]) => {

				let isResumeProcessing = false;
				
				if (metaResponse) {
					isResumeProcessing = Boolean(metaResponse.isAResumeProcessing);
				}

				this.setState({
					isLoading: false,
					errorText: '',

					isResumeProcessing,

					firstName: profileResponse.firstName || '',
					lastName: profileResponse.lastName || '',
					inviteCode: profileResponse.inviteCode || '',
					numInvitesLeft: profileResponse.numInvitesLeft || 0,
					currentStreak: profileResponse.currentStreak || 0,
					longestStreak: profileResponse.longestStreak || 0,
					isFollowing: profileResponse.isFollowing,
				});
			})
			.catch((error) => {
				console.log('dashboard load error', error);

				this.setState({
					isLoading: false,
					errorText: 'Could not load dashboard data right now. Please try again shortly.',
				});
			});
	};

	onLogoutClick = () => {
		utils.removeAuthDetails();
		window.location.href = '/signin';
	};

	onNewLiveResumeCheckInClick = () => {
		window.location.href = '/live-resume';
	};

	setCurrentScreen = (screen) => {
		if (this.state.currentScreen === screen) {
			return;
		}

		this.setState({
			currentScreen: screen,
		});
	};

	getFullName = () => {
		const {
			firstName,
			lastName,
		} = this.state;

		const fullName = `${firstName} ${lastName}`.trim();
		return fullName === '' ? 'Member' : fullName;
	};

	getInitials = () => {
		const {
			firstName,
			lastName,
		} = this.state;

		const initials = `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`.toUpperCase();
		return initials === '' ? 'ME' : initials;
	};

	followUnfollow = () => {
		const {
			nickname,
			isFollowing,
		} = this.state;

		this.setState({
			isFollowing: isFollowing === 1 ? 0 : 1,
		});

		utils.sendRequest('/follow/followUnfollowUser', {
			nickname,
		})
			.then((responseData) => {
			})
			.catch((error) => {
				console.log('follow error', error);
				alert('An error occurred while trying to follow/unfollow the user.');
			});
	};

	// getLatestActiveDate = () => {
	// 	const {
	// 		contributionGraph,
	// 	} = this.state;

	// 	for (let index = contributionGraph.length - 1; index >= 0; index--) {
	// 		if ((contributionGraph[index].count || 0) > 0) {
	// 			return contributionGraph[index].date;
	// 		}
	// 	}

	// 	return 'No activity yet';
	// };


	renderScreenTabs = () => {
		const tabs = [
			{ key: this.screens.checkIns, label: 'Check-Ins', description: 'Dashboard overview' },
			{ key: this.screens.chatter, label: 'Chatter', description: 'Casual Talk' },
			{ key: this.screens.experience, label: 'Experience', description: 'Career history' },
			{ key: this.screens.education, label: 'Education', description: 'Academic background' },
		];

		return (
			<div className={styles.tabBarContainer}>
				<div className={styles.tabBar} role="tablist" aria-label="Dashboard sections">
					{tabs.map((tab) => {
						const isActive = this.state.currentScreen === tab.key;

						return (
							<button
								key={tab.key}
								type="button"
								className={`${styles.tabButton} ${isActive ? styles.tabButtonActive : ''}`}
								role="tab"
								aria-selected={isActive}
								onClick={() => this.setCurrentScreen(tab.key)}
							>
								<span className={styles.tabLabel}>{tab.label}</span>
								<span className={styles.tabDescription}>{tab.description}</span>
							</button>
						);
					})}
				</div>
			</div>
		);
	};

	renderCurrentScreen = () => {
		const {
			currentScreen,
			nickname,
			isSelf,
		} = this.state;
	
		if (currentScreen === this.screens.checkIns) {
			return (
				<DashboardCheckIns
					nickname={nickname}
					isSelf={isSelf}
				/>
			);
		}
		else if (currentScreen === this.screens.chatter) {
			return (
				<DashboardChatter
					nickname={nickname}
					isSelf={isSelf}
					getDialogPortalNode={() => this.chatterLayoutShellDialogHost}
				/>
			);
		}
		else if (currentScreen === this.screens.experience) {
			return (
				<DashboardExperience
					nickname={nickname}
					isSelf={isSelf}
					getDialogPortalNode={() => this.experienceLayoutShellDialogHost}
				/>
			);
		}
		else if (currentScreen === this.screens.education) {
			return (
				<DashboardEducation
					nickname={nickname}
					isSelf={isSelf}
					getDialogPortalNode={() => this.educationLayoutShellDialogHost}
				/>
			);
		}
	};

	render() {
		const {
			isResumeProcessing,
			isSelf,
			isFollowing,
			isLoading,
		} = this.state;

		return (
			<div className={styles.pageContainer}>
				<HQBeta />
				<Sidebar />

				<div className={styles.glowLayer}>
					<div className={styles.glowTop} />
					<div className={styles.glowBottom} />
				</div>

				<div className={styles.layoutShell}>
					<section className={styles.leftPanel}>
						{/* <div className={styles.brandBadge}>HQVibe</div> */}

						<div className={styles.profileBlock}>
							<div className={styles.avatarCircle}>{this.getInitials()}</div>
							<div>
								<h1 className={styles.title}>{this.getFullName()}</h1>
								<p className={styles.subtitle}>
									@{this.state.nickname}
									{isSelf && <span>&nbsp;(This is you)</span>}
								</p>
							</div>
						</div>

						<div className={styles.metricsGrid}>
							{
								isResumeProcessing && (
									<div className={styles.metricCard}>
										<span className={styles.metricLabel}><FiLoader /> Resume Processing</span>
										<strong className={styles.metricValue}>In Progress</strong>
									</div>
								)
							}

							{/* <div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiTrendingUp /> Current Streak</span>
								<strong className={styles.metricValue}>{this.state.currentStreak}</strong>
							</div>

							<div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiThumbsUp /> Longest Streak</span>
								<strong className={styles.metricValue}>{this.state.longestStreak}</strong>
							</div> */}

							{/* todo <div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiActivity /> Total Contributions</span>
								<strong className={styles.metricValue}>{this.state.totalContributions}</strong>
							</div> */}

							{/* <div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiTrendingUp /> Last Active</span>
								<strong className={styles.metricValue}>{this.getLatestActiveDate()}</strong>
							</div> */}

							{/* <div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiCalendar /> Last 90 Days</span>
								<strong className={styles.metricValue}>{this.state.contributionGraph.length} tracked days</strong>
							</div> */}

							{/* todo <div className={styles.metricCard}>
								<span className={styles.metricLabel}><FiAward /> Showing Live Resume Entries</span>
								<strong className={styles.metricValue}>{this.state.recentLiveResumes.length}</strong>
							</div> */}

							<a href="/invite">
								<div className={styles.metricCard}>
									<span className={styles.metricLabel}><FiThumbsUp /> Invite Code</span>
									<strong className={styles.metricValue}>{this.state.inviteCode}</strong>
								</div>
							</a>

							<a href="/invite">
								<div className={styles.metricCard}>
									<span className={styles.metricLabel}><FiUserPlus /> Invites Left</span>
									<strong className={styles.metricValue}>{this.state.numInvitesLeft}</strong>
								</div>
							</a>
						</div>

						{
							isSelf &&
							<button className={styles.primaryButton} onClick={this.onNewLiveResumeCheckInClick}>
								New Check-in <span className={styles.btnArrow}>→</span>
							</button>
						}
						{
							!isSelf && isFollowing !== -1 &&
							(
								isFollowing === 0 ?
								<button className={styles.primaryButton} onClick={this.followUnfollow}>
									Follow <FiUserPlus />
								</button> :
								<button className={styles.secondaryButton} onClick={this.followUnfollow}>
									Unfollow <FiUserMinus />
								</button>
							)
						}
					</section>


					<div>
						{this.renderScreenTabs()}
						<section className={styles.cardPanel}>
							{this.renderCurrentScreen()}
						</section>
					</div>

					<div ref={(node) => { this.educationLayoutShellDialogHost = node; }} />
					<div ref={(node) => { this.chatterLayoutShellDialogHost = node; }} />
					<div ref={(node) => { this.experienceLayoutShellDialogHost = node; }} />
				</div>
			</div>
		);
	};
};